<template>
    <div class="backoffice-members-view">
        <div class="grid">
            <v-card class="menu" elevation="1">
                <div class="user-info">
                    <v-menu bottom left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="menu-dots">mdi-dots-vertical</v-icon>
                        </template>
                        <v-list expand nav dense>
                            <inertia-link :href="'/backoffice/members/details/'+ $page.props.member.id">
                                <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.members.details')}">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ $page.props.lang.account_details || "Account Details" }}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon><v-icon>mdi-account-details-outline</v-icon></v-list-item-icon>
                                </v-list-item>
                            </inertia-link>
                            <v-list-item @click="smsModal = true" link>
                                <v-list-item-content>
                                    <v-list-item-title v-if="use_mobile_app == 1">{{ $page.props.lang.send_message || "Send Message" }}</v-list-item-title>
                                    <v-list-item-title v-else>{{ $page.props.lang.send_sms || "Send SMS" }}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon><v-icon>mdi-email-outline</v-icon></v-list-item-icon>
                            </v-list-item>
                       
                            <v-list-item @click="sendInvitation()" link v-if="$page.props.p['members.manage'] && !$page.props.member.user_id && $page.props.organization.features['portal']">
                                <v-list-item-content>
                                    <v-list-item-title>{{ $page.props.lang.send_invitation || "Send invitation" }}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon><v-icon>mdi-account-plus</v-icon></v-list-item-icon>
                            </v-list-item>
                            <!-- <v-list-item @click="deleteMemberModal = true" link v-show="$page.props.p['members.manage']">
                                <v-list-item-content>
                                    <v-list-item-title>{{ $page.props.lang.delete_member || "Delete member" }}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon><v-icon>mdi-trash-can-outline</v-icon></v-list-item-icon>
                            </v-list-item> -->
                        </v-list>
                    </v-menu>

                    <ConfirmModal :open="deleteMemberModal"
                    @no="deleteMemberModal = false"
                    @yes="deleteMember"
                    @close="deleteMemberModal = false"
                    :description="$page.props.lang.deleteMemberConfirmDescription || 'Are You sure You want to delete this member?'">
                    </ConfirmModal>

                    <div class="image-wrap">
                        <v-progress-circular v-show="imageLoading" class="image-loader" indeterminate color="primary"></v-progress-circular>
                        <img :src="memberData.profile_photo_url + '?w=220'" alt="" v-show="!imageLoading">
                        <div class="upload" v-show="$page.props.p['members.manage']">
                            <v-icon @click="photoModal = true">mdi-camera-outline</v-icon>
                            <v-file-input
                            v-model="memberPhoto"
                            prepend-icon="mdi-camera-outline"
                            @change="onFileChange">
                            </v-file-input>
                        </div>
                    </div>
                    <div class="user">
                        <h3 class="name">{{ memberData.first_name + ' ' + memberData.last_name}}</h3>
                        <p class="email">{{ memberData.email }}</p>
                        <div class="actions">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-show="$page.props.p['members.manage']" color="regular" v-bind="attrs" v-on="on" text small class="status">
                                    <span v-if="memberData.is_active == 1"> {{ $page.props.lang.activeMember || "Active" }} <v-icon x-small color="light-green"> mdi-checkbox-blank-circle </v-icon></span> <span v-else> {{ $page.props.lang.inactiveMember || "Inactive" }} <v-icon x-small color="red"> mdi-checkbox-blank-circle </v-icon> </span>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item @click="changeStatus(true)">
                                        <v-list-item-title>{{ $page.props.lang.activeMember || "Active" }}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="changeMemberStatusInActiveModal = true">
                                        <v-list-item-title>{{ $page.props.lang.inactiveMember || "Inactive" }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <v-btn @click="checkIn({})" :loading="checkInLoading" small color="primary">
                                <span v-if="$page.props.member.is_checkedin == false">{{ $page.props.lang.checkIn || "Check-in" }}</span>
                                <span v-else>{{ $page.props.lang.checkOut || "Check-out" }}</span>
                            </v-btn>
                        </div>
                    </div>
                    
                    <ConfirmModal :open="changeMemberStatusInActiveModal"
                    @no="changeMemberStatusInActiveModal = false"
                    @yes="changeStatus(false), changeMemberStatusInActiveModal = false"
                    @close="changeMemberStatusInActiveModal = false"
                    :description=" $page.props.lang.inactiveConfirmationMessage || 'If you mark member as inactive all his future appointments will be deleted, are you sure you want to make this member inactive?' ">
                    </ConfirmModal>

                    <CheckinModal
                    :modal="checkInModal"
                    :memberSubs="memberSubs"
                    @close="checkInModal = false"
                    @checkin="checkIn">
                    </CheckinModal>
        
                    <v-snackbars :objects.sync="messageObjects" top right>
                        <template v-slot:action="{ close }">
                            <v-btn text @click="close()" icon><v-icon>mdi-close</v-icon></v-btn>
                        </template>
                    </v-snackbars>

                </div>
                <v-divider/>
                <v-list expand nav dense>
                 <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/overview'">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.members.overview')}">
                            <v-list-item-icon><v-icon notranslate mdi theme--light>mdi-view-dashboard-outline</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.overview || "Overview" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                    <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/subscriptions'">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.members.subscription')}">
                            <v-list-item-icon><v-icon>mdi-account-multiple-check-outline</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.subscriptions || "Memberships" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                    <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/payments'" v-show="$page.props.p['members.payments.read']">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.members.payments')}">
                            <v-list-item-icon><v-icon>mdi-account-cash-outline</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.payments || "Payments" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                    <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/notes'" v-show="$page.props.p['members.manage']">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.members.notes')}">
                            <v-list-item-icon><v-icon>mdi-text</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.notes || "Notes" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                    <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/measurements'" v-show="$page.props.p['members.manage'] && $page.props.organization.features['measurement']">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.members.measurements')}">
                            <v-list-item-icon><v-icon>mdi-chart-timeline-variant</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.measurements || "Measurements" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                    <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/visits'" v-show="$page.props.p['members.manage']">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.members.visits')}">
                            <v-list-item-icon><v-icon>mdi-check-all</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.visits || "Visits" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                </v-list>
            </v-card>
            <div @edited="editedMember">
            <slot></slot>
            </div>
        </div>
        <SmsModalMembers
        v-if="smsModal"
        :open="smsModal"
        :sms_credit="sms_credit"
        :use_mobile_app="use_mobile_app"
        :recipients="currentMember"
        @close="smsModal = false">
        </SmsModalMembers>
        <ProfilePhotoModal v-if="photoModal" :open="photoModal" :member="$page.props.member" @close="photoModal = false"></ProfilePhotoModal>
    </div>
</template>

<script>
import ConfirmModal from '@/js/Components/ConfirmModal'
import CheckinModal from '@/js/Components/CheckinModal'
import EventBus from '@/js/eventbus'
import ProfilePhotoModal from '../Components/ProfilePhotoModal'
import SmsModalMembers from '../Components/SmsModalMembers'

export default {
	name: "MemberLayout",
	components: {
		ConfirmModal,
        CheckinModal,
        SmsModalMembers,
        ProfilePhotoModal
	},
    props: {
        lang: Object
    },
	data() {
		return {
			deleteMemberModal: false,
            changeMemberStatusActiveModal: false,
            changeMemberStatusInActiveModal: false,
            memberPhoto: null,
            photoModal: false,
            memberData: this.$page.props.member,
            member_id: this.$page.props.member.id,
            statusItems: [
                { title: this.$page.props.lang.active || 'Active'},
                { title: this.$page.props.lang.inactive || 'Inactive'}
            ],
            messageObjects: [],
            checkInModal: false,
            memberSubs: this.$page.props.member.subscriptions,
            sub: '',
            imageLoading: false,
            checkInLoading: false,
            checkInModel: {
                member_id: this.$page.props.member.id
            },
            smsModal: false,
            use_mobile_app: this.$page.props.use_mobile_app,
            sms_credit:this.$page.props.sms_credit,
            currentMember: [
                {
                full_name: this.$page.props.member.full_name, 
                id:this.$page.props.member.id, 
                profile_photo_url:this.$page.props.member.profile_photo_url
                }
            ]
		}
	},
    methods: {
        goBack() {
            history.back()
        },
        makeActive(status) {
            return changeStatus(status)
        },
        changeStatus(status) {
            axios.post('/backoffice/members/status', {
                    member_id: this.member_id,
                    is_active: status
                })
                .then(response => {
                    if(response.data.status==="OK") {
                        this.memberData.is_active = status ? 1 : 0
                      
                        this.messageObjects.push({ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        this.$inertia.reload();
                    }
                })
        },
        sendInvitation(){
            axios.post('/backoffice/members/sendinvitation', {id: this.$page.props.member.id})
                .then(response => {
                    var color = 'error';
                    if(response.data.status==="OK"){
                        var color = 'success';
                    }
                    this.messageObjects.push({ 
                                message: response.data.message,
                                color: color,
                                timeout: 5000
                            })
                })
                .catch(error => {
                    this.messageObjects.push({ 
                            message: response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
        },
        checkIn(params) {
            this.checkInLoading = true;
            this.checkInModel = Object.assign(this.checkInModel, params)
            axios.post('/backoffice/members/checkin', this.checkInModel)
                .then(response => {
                    this.checkInLoading = false;
                    if (response.data.status==="OK") {

                         EventBus.$emit('SUCCESS_CHECKIN', response.data);

                        this.checkInModal = false;
                        this.checkInModel.card_id = null;
                        this.checkInModel.id = null;
                        this.checkInModel.membership_id = null;
                        this.$inertia.reload()
                    }
                    else if(response.data.status === "CHECKOUT"){

                        EventBus.$emit('SUCCESS_CHECKOUT', response.data);
                        this.checkInModal = false;
                        this.checkInModel.card_id = null;
                        this.checkInModel.id = null;
                        this.checkInModel.membership_id = null;
                        this.$inertia.reload()

                    }
                    else if (response.data.status==="CONFIRM") {
                        this.checkInModal = true
                        this.memberSubs = response.data.subscriptions
                    } else{
                        EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: 'error',
                            timeout: 5000
                        });
                    }
                    this.sub = null
                })
                .catch(error => {
                    this.sub = null;
                    this.checkInLoading = false;
                })
        },
        onFileChange() {
            if(this.memberPhoto) {
                this.imageLoading = true
                let file =  this.memberPhoto
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData()
                formData.append('photo', file)
                formData.append('member_id', this.$page.props.member.id)
                axios.post('/backoffice/members/uploadphoto', formData, config)
                    .then(response => {
                        if (response.data.status==="OK") {
                           
                            this.messageObjects.push({ 
                                    message: response.data.message,
                                    color: 'success',
                                    timeout: 5000
                                })
                            this.imageLoading = false;
                            this.memberData.profile_photo_url = response.data.photo_path;
                        }else{
                            this.messageObjects.push({ 
                                    message: response.data.message,
                                    color: 'error',
                                    timeout: 10000
                                })
                        }
                    })
                    .catch(error => {
                        if(error) {
                            this.messageObjects.push({ 
                                    message: error.response.data.message,
                                    color: 'error',
                                    timeout: 10000
                                })
                            this.imageLoading = false
                        }
                    })
            }
        },
        deleteMember() {
            axios.post('/backoffice/members/delete', {id: this.$page.props.member.id})
                .then(response => {
                    if(response.data.status==="OK") {
                        this.$inertia.visit('/backoffice/members', {method: 'get'})
                    }else{
                        this.messageObjects.push({ 
                            message: response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    }
                })
                .catch(error => {
                    console.log(error.response.data.errors)
                    this.messageObjects.push({ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
		},
		editedMember(value) {
			this.memberData = Object.assign({}, value)
        }
	}
}
</script>
